import { PromoFlagsComponent } from './promo-flags.component';
import { runClientComponent } from '../../_common/client/client-component-runner';

runClientComponent({ PromoFlagsComponent: PromoFlagsComponent });
